class NestedLink {
    static attach() {
        [...document.querySelectorAll(`[data-href]`)].forEach((nestedLink) => {
            const parentLink = nestedLink.closest("a");

            parentLink.addEventListener("click", (event) => {
                NestedLink.handleParentLinkClick(event, { parentLink, nestedLink });
            });
        });
    }

    static handleParentLinkClick(event, { nestedLink }) {
        if (event.target === nestedLink) {
            event.preventDefault();
            if (nestedLink.dataset.linkTarget) {
                window.open(
                    nestedLink.dataset.href,
                    nestedLink.dataset.linkTarget,
                    nestedLink.dataset.linkTarget === "_blank" ? "noreferrer" : ""
                );
            } else {
                window.location.href = nestedLink.dataset.href;
            }
        }
    }
}

export { NestedLink };
